$( document ).ready(function() {
 var c =  $('.mmc-sort-desktop').find('input:checked').val();
    console.log(c);
  $('.mmc-sort-header').html(c);
  $('.mmc-sort-list').slideUp();

$(document).on('change', '.mmc-sort-desktop input', function() {
var h =  $(this).val();
  $('.mmc-sort-header').html(h);
});



$(document).on('click', '.mmc-sort-header', function() {
  $('.mmc-sort-list').slideToggle();
});
$(document).on('click', function (event) {
  if (!$(event.target).closest('.mmc-sort-desktop').length) {
      $('.mmc-sort-list').slideUp();
  }
});
$(document).on('click', '.mmc-sort-desktop  label', function() {
  $('.mmc-sort-list').slideUp();
});

});

$(window).scroll(function() {
  $('.mmc-sort-list').slideUp();
});

$(document).on('change', '#meta_prod', function() {


  if($(this).is(":checked")){
    $(this).closest('.gift-box-product-main').addClass('input_opned');
  }
  else{
     $(this).closest('.gift-box-product-main').removeClass('input_opned');
  }
});

$(document).on('change', '#gift_product', function() {
  if($(this).is(":checked")){
    $(this).closest('.gift-box-product-main').addClass('input_opned');
  }
  else{
     $(this).closest('.gift-box-product-main').removeClass('input_opned');
  }
});


$(document).on('click', '#product-content_input-click-main', function() {
  var $giftBoxProductMain = $(this).closest('.gift-box-product-main');
  var $metaProdCheckbox = $giftBoxProductMain.find("#meta_prod");

  if ($metaProdCheckbox.prop('checked') || !$giftBoxProductMain.hasClass('input_opned')) {
    $giftBoxProductMain.addClass('input_opned');
  } else {
    $giftBoxProductMain.removeClass('input_opned');
  }
});



$(document).on('click', '#product-content_input-click', function() {
  var $giftBoxProductMain = $(this).closest('.gift-box-product-main');
  var $metaProdCheckbox = $giftBoxProductMain.find("#gift_product");

  if ($metaProdCheckbox.prop('checked') || !$giftBoxProductMain.hasClass('input_opned')) {
    $giftBoxProductMain.addClass('input_opned');
  } else {
    $giftBoxProductMain.removeClass('input_opned');
  }
});


/* ------------------------------------------------------------------
   Slide-out cart opener (app-agnostic)
   Opens the theme cart drawer whenever ANY add-to-cart happens via
   AJAX — theme form, Kaching Bundles, Uploadly, Zepto Personalizer,
   quick-add, etc. Passive: it never changes the add request itself,
   it only refreshes + opens the drawer after a successful /cart/add.
   The theme's own product-form opens the drawer directly and sets
   window.__nsSkipNextCartAdd so we don't double-render for it.
------------------------------------------------------------------ */
(function () {
  if (window.__nsCartOpenerInstalled) return;
  window.__nsCartOpenerInstalled = true;

  function isAddUrl(url) {
    try {
      return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    } catch (e) {
      return false;
    }
  }

  var lastOpen = 0;

  // The theme keeps an `is-empty` class on the <cart-drawer> element that hides
  // the items area. renderContents() does not clear it, so the first add from an
  // empty cart would open a blank drawer. Keep the class in sync with whether any
  // cart line items are actually present in the drawer.
  function syncEmptyClass(drawer) {
    try { drawer.classList.toggle('is-empty', !drawer.querySelector('.cart-item')); } catch (e) {}
  }

  // ---- Optimistic add-to-cart ----
  // The click -> server-add -> section-render chain costs 2-3s (Zepto routes
  // even simple adds through its own round-trip). Instead of leaving the page
  // inert for that time, open the drawer the moment ATC is clicked with a
  // loading state; the real contents render in when the add completes. The
  // safety timeout clears the state if no add ever lands (e.g. the app blocked
  // the add for missing personalization), closing the drawer again if the cart
  // is empty so the shopper isn't stranded on a blank cart.
  function clearAdding(drawer) {
    var d = drawer || document.querySelector('cart-drawer');
    if (!d) return;
    d.classList.remove('ns-adding');
    if (window.__nsAddingTO) { clearTimeout(window.__nsAddingTO); window.__nsAddingTO = 0; }
  }

  function startAdding() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    wrapDrawerClose(d);
    d.classList.add('ns-adding');
    d.classList.remove('is-empty');
    window.__nsDrawerClosedAt = 0;
    // Paint the open state synchronously: the theme's open() defers its class
    // adds through a setTimeout, and the personalizer's heavy click work can
    // starve timers for ~1s — the whole point here is instant feedback.
    d.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    try { d.open(); } catch (e) {}
    if (window.__nsAddingTO) clearTimeout(window.__nsAddingTO);
    window.__nsAddingTO = setTimeout(function () {
      var dd = document.querySelector('cart-drawer');
      if (!dd) return;
      dd.classList.remove('ns-adding');
      if (!dd.querySelector('.cart-item')) { try { dd.close(); } catch (e) {} }
      try { syncEmptyClass(dd); } catch (e) {}
    }, 6000);
  }

  // Capture-phase so it fires no matter which app's handler processes the add.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.product-form__submit, button[name="add"]');
    if (!btn) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    // Personalizer / uploader-managed adds only proceed once THAT app's own
    // validation passes — required engraving text, a required photo upload,
    // budget checks. If we optimistically open here, an incomplete/blocked add
    // shows a loading drawer for an item that never lands — the "cart opens with
    // a spinner but nothing was added" bug. Each app tags its own submit button:
    //   - Zepto personalizer  -> `p_a_t_c` (+ required fields `cstmfy_c_required`)
    //   - Uploadly photo upload -> `ph_atc_btn` (blocks with "Please upload a
    //     file!" until a required image is uploaded)
    // For these, do nothing on click: the real completion signals (the
    // pplrAddToCartCompleted event and the /cart/add fetch + XHR wrappers) open
    // the drawer only AFTER the item actually enters the cart — which by
    // definition means the app's validation already passed. This inherits each
    // app's full validation instead of re-implementing it. Non-managed products
    // (rakhis, simple items) keep the instant optimistic open.
    var form = btn.closest('form');
    var managedBtnClasses = ['p_a_t_c', 'ph_atc_btn'];
    var isManaged = false;
    for (var mi = 0; mi < managedBtnClasses.length; mi++) {
      if (btn.classList.contains(managedBtnClasses[mi])) { isManaged = true; break; }
    }
    if (!isManaged && form && form.querySelector('.cstmfy_c_required, [class*="cstmfy_c_required"]')) {
      isManaged = true;
    }
    if (isManaged) return;
    startAdding();
  }, true);

  // Record genuine user-initiated closes (X button, overlay click, Esc) so the
  // race-proof opener below never fights the shopper by re-opening a drawer they
  // just dismissed. Wrapped once, lazily, the first time we touch the drawer.
  function wrapDrawerClose(drawer) {
    if (!drawer || drawer.__nsCloseWrapped || typeof drawer.close !== 'function') return;
    drawer.__nsCloseWrapped = true;
    var origClose = drawer.close.bind(drawer);
    drawer.close = function () {
      window.__nsDrawerClosedAt = Date.now();
      return origClose.apply(drawer, arguments);
    };
    /* Announce opens so the drawer's own script can refresh coupon chips
       event-driven (instead of the old always-on cart polling). */
    if (typeof drawer.open === 'function') {
      var origOpenFn = drawer.open.bind(drawer);
      drawer.open = function () {
        var r = origOpenFn.apply(drawer, arguments);
        try { document.dispatchEvent(new CustomEvent('ns:drawer-opened')); } catch (e) {}
        return r;
      };
    }
    /* Stale-render veto: for a few seconds after a gift add-on lands, apps can
       still push renders built from OLD section snapshots (missing the gift
       row), which made the drawer flicker complete -> incomplete -> complete.
       While the veto window is open, drop any incoming render whose payload
       contains fewer item rows than the real cart. Quantity/remove updates use
       a different render path (CartItems), so they are never affected. */
    if (typeof drawer.renderContents === 'function' && !drawer.__nsRCWrapped) {
      drawer.__nsRCWrapped = true;
      var origRC = drawer.renderContents.bind(drawer);
      drawer.renderContents = function (parsedState) {
        try {
          if (
            window.__nsExpectedLines &&
            Date.now() < (window.__nsVetoUntil || 0) &&
            parsedState && parsedState.sections && parsedState.sections['cart-drawer']
          ) {
            var probe = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
            if (probe.querySelectorAll('.cart-item').length < window.__nsExpectedLines) return;
          }
        } catch (e) {}
        var out = origRC.apply(drawer, arguments);
        // A render landed — the optimistic loading state (if any) is done.
        clearAdding(drawer);
        return out;
      };
    }
  }

  // Race-proof safety net for opening the drawer after an add.
  // The theme's renderContents() opens the drawer from inside a setTimeout whose
  // first line touches #CartDrawer-Overlay. When several apps re-render the cart
  // in quick succession after an add (personalizer, gift add-ons, cart-icon
  // bubble), that overlay can be momentarily absent, the line throws, and the
  // open() call right after it is skipped — so the item is added but the drawer
  // never slides out. Because it depends on render timing, it surfaces on slower
  // / mobile sessions but not reliably on desktop. ensureDrawerOpen() opens the
  // drawer directly (bypassing that fragile path) as soon as cart contents are
  // present, and is scheduled across the whole multi-render window so it catches
  // the drawer whenever the renders settle. It never opens if the shopper just
  // closed the drawer, if the cart is empty, or if it is already open.
  function ensureDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    wrapDrawerClose(drawer);
    // While a gift add-on add is still in flight (personalized products add the
    // main item and the gift box in two sequential requests), hold off — opening
    // early would show a drawer missing the gift box.
    if (window.__nsHoldEnsureUntil && Date.now() < window.__nsHoldEnsureUntil) return;
    // Guard window must exceed the last scheduleEnsureOpen checkpoint (5000ms)
    // so a shopper who dismisses the drawer during the post-add window is never
    // overridden by a late check.
    if (window.__nsDrawerClosedAt && Date.now() - window.__nsDrawerClosedAt < 6000) return;
    if (!drawer.querySelector('.cart-item')) return;
    if (drawer.classList.contains('active')) return;
    try { syncEmptyClass(drawer); drawer.open(); } catch (e) {}
  }

  function scheduleEnsureOpen() {
    wrapDrawerClose(document.querySelector('cart-drawer'));
    var checkpoints = [250, 700, 1300, 2000, 2800, 3800, 5000];
    for (var i = 0; i < checkpoints.length; i++) setTimeout(ensureDrawerOpen, checkpoints[i]);
  }

  function refreshAndOpen(force) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    wrapDrawerClose(drawer);

    var now = Date.now();
    if (!force && now - lastOpen < 400) {
      try { syncEmptyClass(drawer); drawer.open(); } catch (e) {}
      return;
    }
    lastOpen = now;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var sep = root.indexOf('?') === -1 ? '?' : '&';

    fetch(root + sep + 'sections=cart-drawer,cart-icon-bubble', {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        try {
          drawer.renderContents({ sections: data });
        } catch (e) {}
        // Open directly rather than relying on renderContents' internal
        // (overlay-dependent) open, which can silently no-op mid-render.
        try { syncEmptyClass(drawer); drawer.open(); } catch (e) {}
      })
      .catch(function () {
        try { drawer.open(); } catch (e) {}
      });
  }

  // Re-render the drawer's contents from fresh sections WITHOUT opening it.
  // Used when something changes the cart while the drawer is closed (e.g. a
  // Wheelio spin reward) so the next open is already correct.
  function refreshDrawerSilent() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var sep = root.indexOf('?') === -1 ? '?' : '&';
    fetch(root + sep + 'sections=cart-drawer,cart-icon-bubble', {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        try {
          var el = document.getElementById('CartDrawer');
          var fresh = new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('#CartDrawer');
          if (el && fresh) el.innerHTML = fresh.innerHTML;
          var bubble = document.getElementById('cart-icon-bubble');
          var freshBubble = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
          syncEmptyClass(drawer);
          clearAdding(drawer);
        } catch (e) {}
      })
      .catch(function () {});
  }

  // After a gift add-on lands, render once complete — and verify. The sections
  // snapshot fetched immediately after an add can be stale on Shopify's side
  // (eventual consistency), so a render 40ms later sometimes still shows only
  // the main item. Give it a beat, render, then compare the drawer's row count
  // to the real cart; if they differ, force one corrective re-render.
  function verifyDrawerComplete() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = (cart.items || []).length;
        window.__nsExpectedLines = lines; // keep the stale-render veto current
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        var rows = drawer.querySelectorAll('.cart-item').length;
        if (rows !== lines) {
          if (drawer.classList.contains('active')) refreshAndOpen(true);
          else refreshDrawerSilent();
        }
      })
      .catch(function () {});
  }

  function renderCompleteAfterAddon() {
    window.__nsHoldEnsureUntil = 0;
    // Arm the stale-render veto for the settle window.
    window.__nsVetoUntil = Date.now() + 8000;
    // Cart reads themselves can be stale for a beat right after the add-on
    // lands (replica lag) — poll until the cart reports MORE lines than it had
    // before the add-on (captured at hold time), then render once, complete.
    var baseline = window.__nsLinesAtHold || 0;
    var tries = 0;
    function attempt() {
      tries++;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var lines = (cart.items || []).length;
          if (lines > baseline || tries >= 6) {
            window.__nsExpectedLines = lines;
            refreshAndOpen(true);
          } else {
            setTimeout(attempt, 400);
          }
        })
        .catch(function () { refreshAndOpen(true); });
    }
    setTimeout(attempt, 250);
    setTimeout(verifyDrawerComplete, 3200);
    setTimeout(verifyDrawerComplete, 5200);
    scheduleEnsureOpen();
  }

  // Wheelio (and similar apps) reward a spin by hitting Shopify's
  // /discount/CODE endpoint, which only sets a checkout cookie — the cart
  // totals and our drawer chips would not reflect the reward until checkout.
  // When we observe such a call succeed, mirror the code onto the cart via
  // /cart/update.js so the drawer shows the discount live, no refresh needed.
  // If the cart isn't eligible (yet), Shopify marks the code non-applicable:
  // no chip renders, nothing is cleared, and the checkout cookie still stands.
  function syncExternalDiscount(url) {
    try {
      var m = String(url).match(/\/discount\/([^/?#]+)/);
      if (!m) return;
      var code = decodeURIComponent(m[1]);
      if (!code || window.__nsLastSyncedCode === code) return;
      window.__nsLastSyncedCode = code;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      })
        .then(function () {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.classList.contains('active')) {
            refreshAndOpen();
          } else {
            refreshDrawerSilent();
          }
        })
        .catch(function () {});
    } catch (e) {}
  }

  // Exposed so theme code (e.g. the Zepto `pplrAddToCartCompleted` handler in
  // main-product.liquid) can open the slide-out drawer instead of redirecting
  // the browser to the /cart page.
  window.__nsOpenCartDrawer = refreshAndOpen;

  // Backup: when the Zepto personalizer signals an add is complete, make sure
  // the slide-out drawer opens.
  // Gift-box fix: on personalized products the main item and any gift add-ons
  // arrive in TWO sequential server requests (Zepto's own add, then the theme
  // handler's add-on add). Opening after the first one made the gift box
  // "pop in" a second later. If add-ons are selected, hold the first render
  // until the add-on request completes (the loader-cart intercept below fires
  // then) so the drawer opens once, complete. A 5s dead-man's switch opens it
  // regardless in case the theme handler never sends the add.
  window.addEventListener('pplrAddToCartCompleted', function () {
    window.__nsDrawerClosedAt = 0;
    var addonsPending = document.querySelector('#gift_product:checked, #meta_prod:checked');
    if (addonsPending) {
      // Hold until the add-on /cart/add COMPLETES (observed by the fetch/XHR
      // wrappers below, which then clear the hold and render once, complete).
      // The measured add-on round-trip can exceed 3s, so the time cap here is
      // only a dead-man's switch for a handler that never sends the add at all.
      window.__nsHoldEnsureUntil = Date.now() + 5000;
      // Baseline line count BEFORE the add-on lands — the release poll waits
      // for the cart to grow past this before rendering.
      window.__nsLinesAtHold = 0;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { window.__nsLinesAtHold = (cart.items || []).length; })
        .catch(function () {});
      setTimeout(function () {
        if (!window.__nsHoldEnsureUntil) return; // add-on landed, already handled
        renderCompleteAfterAddon();
      }, 5000);
    } else {
      setTimeout(refreshAndOpen, 150);
    }
    scheduleEnsureOpen();
  });

  function onCartAdd() {
    // A fresh add always intends to show the cart: forget any earlier close so
    // the safety net is free to open the drawer.
    window.__nsDrawerClosedAt = 0;
    // If we're holding for a gift add-on, THIS completed add is it — release
    // the hold and render once, complete (main item + add-ons together).
    if (window.__nsHoldEnsureUntil) {
      window.__nsSkipNextCartAdd = false;
      renderCompleteAfterAddon();
      return;
    }
    // The theme product-form opens the drawer itself for its own adds.
    if (window.__nsSkipNextCartAdd) {
      window.__nsSkipNextCartAdd = false;
      // Its open path is the racy one described above — back it up.
      scheduleEnsureOpen();
      return;
    }
    setTimeout(refreshAndOpen, 90);
    scheduleEnsureOpen();
  }

  // --- wrap fetch (observe only, never mutate the request/response) ---
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var method = (init && init.method) || (input && input.method) || 'GET';
      var isAdd = isAddUrl(url) && String(method).toUpperCase() === 'POST';

      // Zepto redirect neutralizer. On personalized products the theme's
      // `pplrAddToCartCompleted` handler (in main-product.liquid) adds any gift
      // add-ons and then runs `window.location.href = '/cart'`, sending the
      // shopper to the cart PAGE instead of the drawer. That handler sets the
      // custom class `loader-cart` on the submit button immediately before its
      // fetch, so we detect it here: send the real add ourselves (add-ons still
      // get added), open the drawer, and return a promise that never resolves —
      // so the handler's `await` never returns and the redirect line is never
      // reached. Scoped by the `loader-cart` marker, so ordinary add-to-cart
      // calls (and the theme's own product-form, which sets __nsSkipNextCartAdd)
      // are never touched.
      if (
        isAdd &&
        !window.__nsSkipNextCartAdd &&
        document.querySelector('cart-drawer') &&
        document.querySelector('.product-form__submit.loader-cart')
      ) {
        window.__nsDrawerClosedAt = 0;
        var real = origFetch.apply(this, arguments);
        real.then(function () {
          // Add-on add finished — release the gift-box hold and render once,
          // complete (main item + gift box together), then verify.
          renderCompleteAfterAddon();
        }).catch(function () {});
        try { if (window.jQuery) window.jQuery('.product-form__submit').removeClass('loader-cart'); } catch (e) {}
        return new Promise(function () {});
      }

      var p = origFetch.apply(this, arguments);
      if (isAdd && p && typeof p.then === 'function') {
        p.then(function (res) {
          try { if (res && (res.ok || res.status === 200)) onCartAdd(); } catch (e) {}
          return res;
        }).catch(function () {});
      }
      // Wheelio spin rewards: /discount/CODE observed -> sync onto the cart.
      if (typeof url === 'string' && url.indexOf('/discount/') !== -1 && p && typeof p.then === 'function') {
        p.then(function (res) {
          setTimeout(function () { syncExternalDiscount(url); }, 150);
          return res;
        }).catch(function () {});
      }
      return p;
    };
  }

  // --- wrap XMLHttpRequest ---
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__nsIsAdd = isAddUrl(url) && String(method).toUpperCase() === 'POST';
    this.__nsDiscountUrl = (typeof url === 'string' && url.indexOf('/discount/') !== -1) ? url : null;
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__nsIsAdd) {
      this.addEventListener('load', function () {
        try {
          if (this.status >= 200 && this.status < 300) onCartAdd();
        } catch (e) {}
      });
    }
    if (this.__nsDiscountUrl) {
      var dUrl = this.__nsDiscountUrl;
      this.addEventListener('load', function () {
        try { setTimeout(function () { syncExternalDiscount(dUrl); }, 150); } catch (e) {}
      });
    }
    return origSend.apply(this, arguments);
  };
})();
